import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Box from "../../components/Box";
import Icon from "../../components/Icon/Icon";
import useOutsideClick from "../../customHooks/useOutsideClick";
import DefaultModal from "../../components/DefaultModal/DefaultModal";
import Button from "../../components/Buttons";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { handleLogOut } from "../../util/Utility";
import { baseUrl } from "../../app.config";

const Header = ({isCollapsed = false}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [value, setValue] = useState("");
  const [show, setShow] = useState(false);
  const [isShown, setIsShown] = useState(false);
    const [showSupportDialog, setShowSupportDialog] = useState(false);
  const [supportItem, setSupportItem] = useState(null);
  const [supportApprovalId, setSupportApprovalId] = useState(null);
  const [supportUser, setSupportUser] = useState(null);
  const { t } = useTranslation();
  const setInitialValue = () => {
    setIsShown(false);
  };
  const user = useSelector((state) => state?.appReducer?.user);
  const approvalList = useSelector((state) => state.appReducer.approvalList);
  const activeEntity = useSelector((state) => state?.adminReducer?.activeEntity);
  const approvalListCount = useSelector(
    (state) => state.appReducer.approvalListCount
  );

  const ref = useOutsideClick(() => setInitialValue());

  const handleClickProfile = () => {
    if (user?.role === "admin") {
      setIsShown((prev) => !prev);
    } else {
      window.location.href = "/user/profile";
    }
  };

  const handleClickLink = (link) => {
    setIsShown(false);
    navigate(link);
  };

  const handleApproval = async(entityId, approvalId, item) => {
    console.log('Item>>>',item)
    if(user?.role === "product_owner"){
      navigate(`/user/mosque/add?entityId=${entityId}&approvalId=${approvalId}`);
    }
    else{
      if(item?.code === "support query"){
        setSupportApprovalId(item?._id);
         const res1 = await fetch(`${baseUrl}/v1/get-support?supportId=${item?.ref_id}`)
         const support = await res1.json();

         const res2 = await fetch(`${baseUrl}onboarding/mosque/${item?.entity_id}/member/${support?.userId}`,{
          headers: {Authorization: `Bearer ${localStorage.getItem('token')}`}
        })
        const user = await res2.json();
        console.log('support item -->', support, user);
        setSupportUser(user);
       setShowSupportDialog(true);

       const { _id: userId, ...restUser } = user;
       const supportItem = { ...support, ...restUser, userId };
       setSupportItem(supportItem);
    }
    else{
    navigate(
      `/user/add-members?memberSubId=${item?.ref_id}&approvalId=${approvalId}`,
      { state: item}
    );
  }
      // navigate(`/user/add-members?entityId=${entityId}&approvalId=${approvalId}`)
    }
    setShow(false);
    //if (entityId && approvalId) {
    //  dispatch(entityApprove(entityId, approvalId));
    //}
  };

  return (
      <div className={isCollapsed ? "header_sec header_sec_collapsed" :"header_sec"} ref={ref}>
        <div className={"header-flex"}>
          <h1>
            {t("Hello")} {user?.contact_name} 👋🏼,
          </h1>
          <div className="d-flex align-items-center">
            {console.log('activeEntity',activeEntity)}
            {(activeEntity && user?.role === "admin") && (
              <Link
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#D0004B" }}
                to={`/mosque/${activeEntity?._id}/member/register `}
              >
                Standalone Form
              </Link>
            )}

            {user?.role !== 'viewer' && <div>
              <div className="noti-msg" onClick={() => setShow(true)}>
                {!show && (
                  <span className="notification">{approvalListCount}</span>
                )}
                {!show ? <Icon iconName="BellIcon" /> : <Box width="21px" />}
              </div>
            </div>}
            <div
              className="admin-profile-links"
              style={{ cursor: "pointer" }}
              onClick={() => handleClickProfile()}
            >
              <div className="profile-im">
                {user?.profile_pic ? (
                  <img
                    src={user?.profile_pic}
                    alt="profile"
                    width="45px"
                    height="45px"
                    style={{ borderRadius: "50%" }}
                  />
                ) : (
                  <Box
                    width="40px"
                    height="40px"
                    borderRadius="50%"
                    bg="#D0004B"
                  >
                    <div
                      className={"text-center"}
                      style={{ paddingTop: "8px", color: "white" }}
                    >
                      {user && user.contact_name ? user?.contact_name[0] : ""}
                    </div>
                  </Box>
                )}
              </div>
             {user?.role === "admin"&& <div style={{ position: "absolute", right: "0px" }}>
                <Icon
                  iconName="rightIcon"
                  style={
                    isShown
                      ? { cursor: "pointer", transform: "rotate(180deg)" }
                      : { cursor: "pointer" }
                  }
                  iconSize="tiny"
                />
              </div>}
            </div>
            {isShown && (
              <ul className="admin-profile-links-ul">
                <li
                  onClick={() =>
                    handleClickLink(`/user/profile`)
                  }
                >
                  {t("My Profile")}
                </li>
                <li onClick={() => handleLogOut(true)}>{t("Logout")}</li>
              </ul>
            )}
          </div>
        </div>
      <DefaultModal
        show={show}
        onHide={() => setShow(false)}
        className="notification-modal"
        style={{ paddingRight: "0px" }}
        centered={false}
        showHeader={false}
        size=""
        showFooter={false}
      >
        <div className="noti-msg-white" onClick={() => setShow(true)}>
          <span className="notification">{approvalListCount}</span>
          <Icon iconName="BellIconWhite" />
        </div>
        <div className="noti-popup">
          <div className="d-flex justify-content-between noti-heading">
            <h5>{t("Notifications")}</h5>
            {/*<h6>Mark As Read</h6>*/}
          </div>
          <div className="modal-scroll">
            {approvalList &&
              approvalList.map((item, i) => (
                <div key={i}>
                  <div className="border-bottom mb-2"></div>
                  <div className="msg-notification">
                    <span className="dot"></span>
                    <div className="bblue">{"#"}</div>
                    <div className="ml-4">
                      <p>
                        <b>{item?.task_name} </b>
                      </p>
                      <small>{item?.created_at.substring(0, 10)}</small>
                      <p>
                        <Box my="10px">
                          <Box>
                            <Button
                              type="outlineColor"
                              minHeight="35px"
                              text={t("Review")}
                              onClick={() =>
                                handleApproval(item?.ref_id, item?._id,item)
                              }
                            />
                          </Box>
                        </Box>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </DefaultModal>
    </div>
  );
};

export default Header;
